export {
  default as other,
  ReactComponent as Other,
} from '@assets/icons/features-and-amenities/other.svg'    
